module.exports = __webpack_public_path__ + "img/html.09ce7b6e.svg";